import { SET_CHART_RANGE, REMOVE_CHART_RANGE } from "./types";

export const setChartRange = (data) => {
  return {
    type: SET_CHART_RANGE,
    payload: data,
  };
};

export const removeChangeRange = (chartId) => {
  return {
    type: REMOVE_CHART_RANGE,
    payload: {
      chartId,
    },
  };
};
